<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Użytkownicy</span>
        <h3 class="page-title">Dodawanie nowego użytkownika</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/uzytkownicy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          Dodaj użytkownika
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>

            <validation-observer ref="user-new-form" tag="form">
              <div class="form-group">
                <label for="name">
                  Imię i nazwisko:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="email">
                  E-mail:
                </label>

                <validation-provider
                  rules="required|email"
                  name="email"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="email"
                    v-model="email" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="email">
                  Hasło:
                </label>

                <validation-provider
                  rules="required|min:6"
                  name="original-password"
                  v-slot="{ errors }">
                  <d-input
                    type="password"
                    :state="errors.length ? 'invalid' : null"
                    v-model="password" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="email">
                  Powtórz hasło:
                </label>

                <validation-provider
                  rules="required|password:original-password"
                  name="password-confirmation"
                  v-slot="{ errors }">
                  <d-input
                    type="password"
                    :state="errors.length ? 'invalid' : null"
                    v-model="passwordConfirmation" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label class="d-block">
                  Rodzaj konta
                </label>
                <d-form-radio inline v-model="type" value="ADMIN">
                  Administrator
                </d-form-radio>
                <d-form-radio inline v-model="type" value="USER">
                  Pracownik
                </d-form-radio>
              </div>

            </validation-observer>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import SanitizeUtils from './../../utils/SanitizeUtils';

export default {
  name: 'user-new',
  data() {
    return {
      name: '',
      email: '',
      type: 'worker',
      active: true,
      password: '',
      passwordConfirmation: ''
    };
  },
  async mounted () {
    try {
      await SanitizeUtils.checkPermissions(this)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['user-new-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/users/store',
        formData: {
          name: this.name,
          email: this.email,
          type: this.type,
          active: this.active ? 1 : 0,
          password: this.password,
          password_confirmation: this.passwordConfirmation
        },
        successTitle: 'Dodano użytkownika',
        successText: 'Podany użytkownik został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Dodawanie użytkownika nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/uzytkownicy')
        }
      });
    }
  }
};
</script>
